const LIFTSEARCH_URL = "https://liftsearch.co.za";
const FACEBOOK_URL = "https://www.facebook.com/parcelin";
const TWITTER_URL = "https://twitter.com/parcelin";
const INSTAGRAM_URL = "https://www.instagram.com/parcelin";

export { LIFTSEARCH_URL, FACEBOOK_URL, TWITTER_URL, INSTAGRAM_URL };
